import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getActivityTypeAPI } from "./views/activity-service";

interface ActivityType {
  id: number;
  name: string;
  icon: string;
  default_user_id: boolean;
}

interface ActivityTypesState {
  types: ActivityType[];
  loading: boolean;
  error: string | null;
}

const initialState: ActivityTypesState = {
  types: [],
  loading: false,
  error: null
};

export const getActivityTypes = createAsyncThunk(
  "activity/getActivityTypes",
  getActivityTypeAPI
);

const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    setActivityTypes: (state, action: PayloadAction<ActivityType[]>) => {
      state.types = action.payload;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActivityTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getActivityTypes.fulfilled, (state, action: PayloadAction<ActivityType[]>) => {
        state.loading = false;
        state.types = action.payload;
        console.log("getActivityType called", action.payload);
      })
      .addCase(getActivityTypes.rejected, (state, action) => {
        state.loading = false;
        console.error("Activity types fetch failed:", action.error);
      });
  }
});

export const { setActivityTypes } = activitySlice.actions;
export default activitySlice.reducer;